import React from 'react';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import { useTranslation } from 'react-i18next';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { makeStyles } from '@mui/styles';

import Popper from "@mui/material/Popper";

import Checkbox from '@mui/material/Checkbox';

import CheckBoxIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import MDBox from '../components/MDBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const styles = (theme) => ({
    popper: {
        maxWidth: "fit-content"
    }
});



const useStyles = makeStyles({
    option:
    {       
        fontSize: 12,        
        marginTop: 2.2,
        '& label':
        {           
            fontSize: 12,
            fontWeight: "400",
            color: '#aaaaaa'
        },       
        '& div':
        {           
        },        
        '& input': {
            fontSize: 12,
            fontWeight: "400",            
            color: '#000000',    
            marginBottom: 4,            
        },
        '& > span': {
            marginRight: 5,            
            fontSize: 18,
            color: '#d2d2d2',            
        }       
    }
});

export default function OthelloEditComboBox({ ...props })
{
    const classes = useStyles();

    const { t } = useTranslation();

    const {
        othellocolumnas,
        multiple
    } = props;

    const [indexcampoBusqueda, setIndexCampoBusqueda] = React.useState(0);

    const [valueselected, setValueSelected] = React.useState(null);
    const [visibefield, setVisibeField] = React.useState(false);    
    const [itemsEditCombo, setItemsEditCombo] = React.useState(null);
    const [evento, setEvento] = React.useState({ event: false });

    React.useEffect(() => {

        //Si se ha modificado la lista del combo
        if (ItemsComboDintintos())
        {
            //si la nueva lista tiene valores
            if (props.items != null && props.items.length > 0)
            {
                //modifico la lista de items
                setItemsEditCombo(props.items);

                //actualizo el valor seleccionado
                ActualizarValueSelected();                
            }
            //sino, es que la lista es vacia o nula, por tanto, si habia un valor seleccionado debo limpiar
            else if (valueselected != null)
                setValueSelected(null);
        }
        //si no se ha generado ningun evento entonces tratamos el mediante el currentvalue
        else if (!evento.event && ((valueselected == null && props.currentvalue != null) || (valueselected != null && props.currentvalue == null) ||
                (valueselected != null && props.currentvalue != null) && valueselected.valor != props.currentvalue)) {
            ActualizarValueSelected();            
        }       
    });

    function ActualizarValueSelected() {

        if (props.multiple) {
            let res = [];

            let opc = props.currentvalue.split(',');

            if (opc != null && opc.length > 0) {
                opc.map(x => {
                    let item = props.items.find(y => y.valor == x);

                    if (item != null)
                        res.push(item);
                })
            }

            if (res != [])
                setValueSelected(res);
        }
        else
        {
            //si el valor esta dentro de los items
            if (props.items.some(x => props.currentvalue == x.valor)) {
                let res = props.items.find(x => props.currentvalue == x.valor);
                setValueSelected(res);
            }
            //si no se encontro el valor seleccionado es distinto de null lo limpio
            else if (valueselected != null)
                setValueSelected(null);
        }
    }

    function ItemsComboDintintos()
    {
        if (props.items == null || (props.items != null && props.items.length === 0)) {

            return true;
        }
        else {
            let DeleteItems = (props.items != null && props.items.length > 0 && (itemsEditCombo == null || itemsEditCombo == []));
            let NuevosItems = (itemsEditCombo != null && itemsEditCombo.length > 0 && (props.items == null || props.items == []));
            let CambioItems = false;

            if (props.items != null && props.items.length > 0 && itemsEditCombo != null && itemsEditCombo.length > 0) {

                if (props.items.some(x => !itemsEditCombo.some(y => y.valor == x.valor)))
                    CambioItems = true;
            }

            if (DeleteItems || NuevosItems || CambioItems)
               return true;
        }

        return false;
    }

    const onTagsChange = (event, values) => {
        if (event != null) {
            if (values != valueselected)
            {
                setEvento({event: true})

                setValueSelected(values);

                if (props.onChange != null)
                    props.onChange(values);     
            }
        }
    }

    const handleKeyDown = (event) => {

        //Si se pulso el boton izquierdo y estbamos en la posicion cero
        if (event != null && event.key == "ArrowLeft" && event.target != null && event.target.selectionStart == 0 && (event.target.value == null || (event.target.value != null && event.target.value == ""))) {
            if (othellocolumnas != null && othellocolumnas.length > 0) {
                let newindex = indexcampoBusqueda + 1;
                if (newindex >= othellocolumnas.length)
                    newindex = 0;

                setIndexCampoBusqueda(newindex);
                setVisibeField(true);
            }
        }
    }

    const handleOnFocusOut = (event) => {
        if (event != null) {
            if (visibefield)
                setVisibeField(false);
        }
    } 

    const getCampoBusqueda = (index) => {
        if (othellocolumnas != null && othellocolumnas.length > 0)
            return othellocolumnas[index].fieldname;
        else
            return "name";
    }

    const getFieldLiteralName = (index) => {
        if (othellocolumnas != null && othellocolumnas.length > 0)
            return t(othellocolumnas[index].fieldliteralname);
        else
            return "";
    }

    const getCurrentValue = () =>
    {
        if (valueselected != null)
        {
            //Si estamos con multiples
            if (props.multiple) {
                if (valueselected.length > 0)
                    return valueselected.map(x => x.valor).join(",");
                else
                    return 0;
            }
            else
                return valueselected.valor;
        }
        else
            return 0;
    }     

    const PopperMy = function (props) {
        return <Popper {...props} style={styles.popper} style={{ paddingTop: visibefield ? 15 : 0}} placement="bottom-start" />;
    };

    let width = 0;

    if (othellocolumnas != null && othellocolumnas.length > 0)
        othellocolumnas.forEach(x => width = width + x.width);
    else
        width = 'auto';

    return (
        <MDBox px={1} >
            <input id={props.fieldname} name={props.fieldname} type="hidden" value={getCurrentValue()} />
            <Autocomplete
                id={props.fieldname != null ? props.fieldname : null}
                className={classes.option}
                multiple={multiple != null ? multiple : false}
                PopperComponent={PopperMy}
                options={props.items != null && props.items.length>0 ? props.items : []}
                value={valueselected != null ? valueselected : (multiple != null && multiple ? [] : null )}
                getOptionLabel={(option) => option[getCampoBusqueda(indexcampoBusqueda)]}
                onChange={onTagsChange}        
                defaultValue={null}
                renderOption={(props, option, { selected }) => (
                    <li {...props} style={{ fontSize: 11, width: width }} >
                        {multiple != null && multiple ?
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            /> : ""} 
                        {othellocolumnas != null && othellocolumnas.length > 0 ?
                            othellocolumnas.map(x => <div style={{ width: x.width, float: "left" }}><span>{option[x.fieldname]}</span></div>)
                            : <span>{option.name}</span>
                            }
                    </li >)}
                renderInput={(params) => <div><TextField className={classes.option} {...params} label={t != null && props.labelliteral != null ? t(props.labelliteral) : props.label} variant="standard" onKeyDown={handleKeyDown} onBlur={handleOnFocusOut} />
                    <React.Fragment>
                        {visibefield ? <p>{getFieldLiteralName(indexcampoBusqueda)}</p> : null}
                    </React.Fragment></div>}            
            />           
        </MDBox>
    );
}


OthelloEditComboBox.propTypes = {

    labelliteral: PropTypes.string,
    label: PropTypes.string,
    fieldname: PropTypes.string,
    currentvalue: PropTypes.object,
    readonly: PropTypes.bool,   
    items: PropTypes.object.isRequired, //Los items debe implementar IFiltroModel
    //Evento que salta al seleccionar un item
    onChange: PropTypes.object,
    //Array de clse { fieldname: "campo", fieldliteralname: "_nombre", width : 250  }
    othellocolumnas: PropTypes.object,   
    //Para tratar si es una lista de checks
    multiple: PropTypes.bool  
};    